export default __webpack_public_path__ + "static/media/Christina 9781408347317.f2170ed3.jpg";